import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { PlayerProvider, usePlayer } from "@/context/PlayerContext";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ConsolePlayer } from "@/components/layout/ConsolePlayer";
import { CartDrawer } from "@/components/layout/CartDrawer";
import { GrowTheListPopup } from "@/components/site/GrowTheListPopup";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Merch from "@/pages/Merch";
import AlbumPage from "@/pages/AlbumPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ShippingReturns from "@/pages/ShippingReturns";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import NotFound from "@/pages/NotFound";
import AdminApp from "@/admin/AdminApp";

const NoIndex = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const admin = pathname.startsWith("/admin");
    let tag = document.querySelector('meta[name="robots"]');
    if (admin) {
      if (!tag) { tag = document.createElement("meta"); tag.name = "robots"; document.head.appendChild(tag); }
      tag.content = "noindex, nofollow";
    } else if (tag) {
      tag.content = "index, follow";
    }
  }, [pathname]);
  return null;
};

const PublicShell = () => (
  <>
    <SmoothScroll />
    <div className="grain-overlay" aria-hidden="true" style={{ backgroundImage: "url(/noise.png)" }} />
    <Header />
    <CartDrawer />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/merch" element={<Merch />} />
      <Route path="/album/:id" element={<AlbumPage />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/shipping-returns" element={<ShippingReturns />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Footer />
    <ConsolePlayer />
    <GrowTheListPopup />
  </>
);

function SiteToaster() {
  const player = usePlayer();
  const lifted = player?.hasStarted && player?.track && !window.location.pathname.startsWith("/admin");
  return <Toaster position="bottom-center" offset={lifted ? 120 : 32} toastOptions={{ style: { background: "var(--ink-raised)", border: "1px solid var(--gold)", color: "var(--parchment)", fontFamily: "var(--body)" } }} />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SiteProvider>
          <PlayerProvider>
            <CartProvider>
              <NoIndex />
              <Routes>
                <Route path="/admin/*" element={<AdminApp />} />
                <Route path="/*" element={<PublicShell />} />
              </Routes>
              <SiteToaster />
            </CartProvider>
          </PlayerProvider>
        </SiteProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
